import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Trans } from '@lingui/react';
import { t } from '@lingui/macro';
import { useLocalisation } from '@3plearning/lingui-cdn';

// Components
import Checkbox, { LABEL_STYLES } from '../checkbox/checkbox';
import StudentPassword from '../student-password/student-password';
import SelectLabel from '../select-label/select-label';

// Helpers
import { stripCharacters } from '../../helpers/utils';
import { PRODUCT_IDS } from '../../helpers/enums';

function MainListBody(props) {
    const { i18n } = useLocalisation();
    const {
        userId,
        firstName,
        lastName,
        index,
        username,
        password,
        changePassword,
        shownPassword,
        setShownPassword,
        filteredClassGroups,
        groupId,
        courseName,
        upfCourseName,
        conquestCourseName,
        isSelected,
        selectHandler,
        productId,
        checkboxHandler,
        showNewCourses,
        oneRosterUserId
    } = props;

    const isMathletics = productId === PRODUCT_IDS.Mathletics.toString();
    const studentKey = `studentRow${firstName}${lastName}`;
    const id = stripCharacters(`${studentKey}${index}`);
    const changeGroupHandler = (e) => {
        const newGroupId = e.target.value;
        selectHandler({ newGroupId, userIds: [userId] });
    };
    const groupComponent = (user, group) => (
        <SelectLabel
            id={`groups-${user}`}
            srLabel={`${i18n._(t`Header - Group`)}-${user}`}
            listOfOptions={filteredClassGroups}
            value={group}
            propertyName="groupId"
            isSelectDisabled={filteredClassGroups.length <= 1}
            selectHandler={changeGroupHandler}
        />
    );

    const localCheckboxHandler = useCallback(() => {
        checkboxHandler(userId);
    }, [userId]);
    const name = `${lastName}, ${firstName}`;

    return (
        <tr className={`table__row ${isSelected ? 'table__row--selected' : ''}`}>
            <td className="table__cell table__cell--checkbox">
                <Checkbox
                    uid={id}
                    isChecked={isSelected}
                    callback={localCheckboxHandler}
                    labelText={`${username}-${index}`}
                    inputType={LABEL_STYLES.hidden}
                />
            </td>
            <td className="table__cell table__cell--name">
                <span title={name} className="text-ellipsis">
                    {name}
                </span>
            </td>
            <td className="table__cell table__cell--detail">{username}</td>
            <td className="table__cell table__cell--password">
                <StudentPassword
                    id={id}
                    userId={userId}
                    password={password}
                    changePassword={changePassword}
                    shownPassword={shownPassword}
                    setShownPassword={setShownPassword}
                    oneRosterUserId={oneRosterUserId}
                />
            </td>
            <td className="table__cell">{groupComponent(userId, groupId)}</td>
            <td
                className={`table__cell table__cell--course ${
                    isMathletics && courseName ? 'table__cell--upfcourse' : ''
                }`}
            >
                <span
                    title={courseName}
                    className={`${courseName ? 'text-ellipsis' : 'table__cell--no-course-assigned'}`}>
                    <Trans id={'Course assigned - Activities'} />{courseName}
                </span>
                {showNewCourses && (
                    <span
                        title={conquestCourseName}
                        className={`${conquestCourseName ? 'text-ellipsis' : 'table__cell--no-course-assigned'}`}>
                        <Trans id={'Course assigned - New Courses'} />
                        {conquestCourseName || i18n._(t`No course assigned`)}
                    </span>
                )}
                {isMathletics && (
                    <span
                        title={upfCourseName}
                        className={`${upfCourseName ? 'text-ellipsis' : 'table__cell--no-course-assigned'}`}>
                        <Trans id={'Course assigned - Skill Quests'} />
                        {upfCourseName || i18n._(t`Group Modal - label - Select no courses`)}
                    </span>
                )}
            </td>
        </tr>
    );
}

MainListBody.propTypes = {
    userId: PropTypes.number,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    index: PropTypes.number,
    username: PropTypes.string,
    password: PropTypes.string,
    changePassword: PropTypes.func.isRequired,
    shownPassword: PropTypes.string,
    setShownPassword: PropTypes.func,
    filteredClassGroups: PropTypes.array,
    groupId: PropTypes.number,
    courseName: PropTypes.string,
    upfCourseName: PropTypes.string,
    conquestCourseName: PropTypes.string,
    isSelected: PropTypes.bool,
    selectHandler: PropTypes.func,
    productId: PropTypes.string,
    checkboxHandler: PropTypes.func,
    showNewCourses: PropTypes.bool,
    oneRosterUserId: PropTypes.string
};

export default MainListBody;



// WEBPACK FOOTER //
// ./components/students-lists/main-list-body.js